import type { SidebarNavItem } from '@/lib/api'
import { adminRoutes, workerRoutes } from '@/lib/navigation/routes'

/** Default admin sidebar when /api/sidebar is unavailable. */
export const defaultAdminSidebar: SidebarNavItem[] = [
  { icon: 'dashboard', label: 'Панель', path: adminRoutes.dashboard.path, match: [adminRoutes.dashboard.path] },
  { icon: 'nomenclature', label: 'Номенклатура', path: adminRoutes.nomenclature.path, match: [adminRoutes.nomenclature.path] },
  { icon: 'tasks', label: 'Задания', path: adminRoutes.tasks.path, match: ['/admin/tasks'] },
  { icon: 'document', label: 'Создать задание', path: '/admin/tasks/new', match: ['/admin/tasks/new'] },
  { icon: 'shipments', label: 'Отгрузки', path: adminRoutes.shipments.path, match: [adminRoutes.shipments.path] },
  { icon: 'fields', label: 'Метаданные', path: adminRoutes.metadata.path, match: [adminRoutes.metadata.path] },
  { icon: 'labels', label: 'Шаблоны КА', path: adminRoutes.kaTemplates.path, match: [adminRoutes.kaTemplates.path] },
  { icon: 'document', label: 'Генерация КА', path: adminRoutes.kaGeneration.path, match: [adminRoutes.kaGeneration.path] },
  { icon: 'contractor', label: 'Контрагенты', path: adminRoutes.contractors.path, match: [adminRoutes.contractors.path] },
  { icon: 'settings', label: 'Настройки', path: adminRoutes.settings.path, match: [adminRoutes.settings.path, '/admin/settings'] },
  { icon: 'infrastructure', label: 'Инфраструктура', path: adminRoutes.infrastructure.path, match: [adminRoutes.infrastructure.path] },
]

export const defaultWorkerSidebar: SidebarNavItem[] = [
  { icon: 'dashboard', label: 'Главная', path: workerRoutes.dashboard.path, match: [workerRoutes.dashboard.path] },
  { icon: 'tasks', label: 'Задания', path: workerRoutes.tasks.path, match: ['/worker/tasks'] },
  { icon: 'shipments', label: 'Отгрузки', path: workerRoutes.shipments.path, match: [workerRoutes.shipments.path] },
]

export function getDefaultSidebar(role: string | null | undefined): SidebarNavItem[] {
  return role === 'worker' ? defaultWorkerSidebar : defaultAdminSidebar
}
